import {type Mock, vi} from 'vitest'
/** @internal */
export const createStudioWorker: Mock = vi.fn()
/** @internal */
export const studioWorkerTask: Mock = vi.fn()
/** @internal */
export const tsxWorkerTask: Mock = vi.fn()
